import React, { useState } from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DocumentGrid } from '../../components/documents/DocumentGrid';
import { DocumentUpload } from '../../components/tenant/DocumentUpload';
import { motion } from 'framer-motion';
import { Upload, Filter } from 'lucide-react';
import { useToast } from '../../hooks/useToast';
export function DocumentVault() {
  const {
    toast
  } = useToast();
  const [activeFilter, setActiveFilter] = useState('All Documents');
  const [isUploading, setIsUploading] = useState(false);
  const handleUpload = async (file: File) => {
    setIsUploading(true);
    // Simulate upload
    setTimeout(() => {
      setIsUploading(false);
      toast.success(`${file.name} uploaded successfully`);
    }, 2000);
  };
  return <div className="flex min-h-screen bg-gray-50 pb-16 lg:pb-0" data-id="element-4686">
      <Sidebar data-id="element-4687" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4688">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-4689">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4690">
            <div className="flex justify-between items-center mb-8" data-id="element-4691">
              <div data-id="element-4692">
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-4693">
                  Document Vault
                </h1>
                <p className="mt-1 text-sm text-gray-500" data-id="element-4694">
                  Securely store and manage your rental documents.
                </p>
              </div>
              <button onClick={() => document.getElementById('file-upload')?.click()} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors" data-id="element-4695">
                <Upload className="h-4 w-4 mr-2" data-id="element-4696" />
                Upload New
              </button>
            </div>

            {/* Upload Area */}
            <div className="mb-10" data-id="element-4697">
              <DocumentUpload title="Quick Upload" description="Drag and drop files here to add to your vault" acceptedTypes=".pdf,.jpg,.png" onUpload={handleUpload} data-id="element-4698" />
            </div>

            {/* Filters */}
            <div className="flex items-center space-x-2 mb-6 overflow-x-auto pb-2 scrollbar-hide" data-id="element-4699">
              {['All Documents', 'Agreements', 'Receipts', 'ID Cards'].map(filter => <button key={filter} onClick={() => setActiveFilter(filter)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeFilter === filter ? 'bg-blue-50 text-blue-700 border border-blue-200' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`} data-id="element-4700">
                    {filter}
                  </button>)}
              <button className="ml-auto p-2 text-gray-400 hover:text-gray-600" data-id="element-4701">
                <Filter className="h-5 w-5" data-id="element-4702" />
              </button>
            </div>

            <DocumentGrid data-id="element-4703" />
          </motion.div>
        </div>
      </main>
    </div>;
}